import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

import { ReactComponent as ArrowsPointingOut } from 'assets/icons/ArrowsPointingOut.svg';

import { IFullScreenButtonProps } from './types';

import styles from './FullScreenButton.module.scss';

export const FullScreenButton: FC<IFullScreenButtonProps> = ({ onClick, disabled }) => {
  const { t } = useTranslation();

  return (
    <Box className={styles.fullScreenTextContainer}>
      <Typography
        onClick={onClick}
        color="primary"
        variant="h6"
        className={clsx(styles.fullScreenText, { [styles.disabled]: disabled })}
      >
        {t('fullScreen')}
        <ArrowsPointingOut />
      </Typography>
    </Box>
  );
};
